import omit from 'lodash/omit';
import createPromiseThunk from "~/rx/lib/createPromiseThunk";
import fetchModelTableResults from '~/rx/lib/fetchTableResults';
import {defaultTableResults} from "~/config";
import {getFormattedResultParams} from "~/stateGetter";
import createReduceResults from "~/rx/lib/reduceResults";

const tableResults = createPromiseThunk({
    func: fetchModelTableResults,
    name: 'tableResults',
    defaultValue: defaultTableResults
});

let execute = tableResults.execute;
tableResults.execute = (modelId, cancelToken) => execute({modelId, cancelToken}, {modelId});
tableResults.reduce = createReduceResults({
    promiseThunk: tableResults,
    getParams: (results, state, model) => {
        return omit(getFormattedResultParams(state, model.modelId), ['itemId'])
    },
    reduceOriginal: tableResults.reduce
});

const reduceTableResults = tableResults.reduce,
    TABLE_RESULT_TYPES = tableResults.types,
    fetchTableResults = tableResults.execute;

export {
    TABLE_RESULT_TYPES,
    reduceTableResults,
    fetchTableResults
}